import styled from 'styled-components';

export const StyledMdContent = styled.div``;
